import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.timer = null
  }

  input() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  change(event) {
    // Prefents text input on change (when blured) submitting the form
    // it causes race condition when after typing user right away clears filters with btn
    if (event.target.tagName !== "SELECT") return

    clearTimeout(this.timer)
    this.submit()
  }

  submit() {
    const form = this.element.closest("form")
    if (!form) return
    const submitter = this.element.querySelector("button[data-turbo-frame]")
    form.requestSubmit(submitter || null)
  }
}
